import type { BundleDeal, BuyXGetYDeal } from "@/lib/api/types";
import { formatCents } from "@/lib/utils/number";

type Props = {
  bundles: BundleDeal[];
  multiBuys: BuyXGetYDeal[];
  onSelectBundle: (deal: BundleDeal) => void;
  onSelectMultiBuy: (deal: BuyXGetYDeal) => void;
};

/** Lists the Combo/Multi-buy deals a menu item deletion will cascade-delete, each row opening a read-only detail dialog. */
export function DependentDealsList({
  bundles,
  multiBuys,
  onSelectBundle,
  onSelectMultiBuy,
}: Props) {
  return (
    <div className="space-y-3">
      <p>
        This item is part of the following deals. Deleting it will also permanently delete these
        deals:
      </p>
      <div className="border rounded-md divide-y divide-border max-h-56 overflow-y-auto">
        {bundles.map((deal) => (
          <button
            key={`bundle-${deal.id}`}
            type="button"
            onClick={() => onSelectBundle(deal)}
            className="w-full min-w-0 px-3 py-2 text-left hover:bg-muted transition-colors"
          >
            <p className="text-sm font-medium text-foreground truncate">{deal.name}</p>
            <p className="text-xs text-muted-foreground truncate">
              Combo · {deal.items.map((it) => it.menu_item.name).join(", ")} ·{" "}
              {formatCents(deal.bundle_price_cents)}
            </p>
          </button>
        ))}
        {multiBuys.map((deal) => (
          <button
            key={`multibuy-${deal.id}`}
            type="button"
            onClick={() => onSelectMultiBuy(deal)}
            className="w-full min-w-0 px-3 py-2 text-left hover:bg-muted transition-colors"
          >
            <p className="text-sm font-medium text-foreground truncate">{deal.name}</p>
            <p className="text-xs text-muted-foreground truncate">Multi-buy · {deal.rule_label}</p>
          </button>
        ))}
      </div>
    </div>
  );
}
